export const COMPETITORS_CSV_FILENAME = 'competitors.csv'

const COMPETITORS_CSV_HEADERS = [
  'Rank',
  'Brand',
  'Domain',
  'Share of mentions',
  'Mentions',
  'Mention rate',
  'Mentioned answers',
  'Avg. rank',
  'Head-to-head'
]

function escapeCsvValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  const stringValue = String(value)
  if (!/[",\r\n]/.test(stringValue)) {
    return stringValue
  }

  return `"${stringValue.replace(/"/g, '""')}"`
}

export function buildCompetitorsCsv(rows = []) {
  const csvRows = [
    COMPETITORS_CSV_HEADERS,
    ...rows.map(row => [
      row.rank,
      row.brandName || row.displayName,
      row.domain,
      `${Number(row.sharePercent || 0)}%`,
      row.mentionCountLabel,
      `${Number(row.mentionRatePercent || 0)}%`,
      row.mentionedAnswersLabel,
      row.averagePositionLabel,
      row.headToHead?.label,
    ]),
  ]

  return csvRows.map(row => row.map(escapeCsvValue).join(',')).join('\n')
}

export function downloadCsv(csv, fileName) {
  const csvFile = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
  const downloadLink = document.createElement('a')
  const url = window.URL.createObjectURL(csvFile)

  downloadLink.download = fileName
  downloadLink.href = url
  downloadLink.style.display = 'none'
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
  window.URL.revokeObjectURL(url)
}
